import styled from 'styled-components'

export const AmbassadorWrapper = styled.div`
  padding: 0 50px;
  background-color: ${props => props.theme.colors.alabaster};

  .upload-document {
    margin-top: 30px;
  }
  .settings {
    padding-left: 55px;
  }
`
